<template>
  <div class="linkfield" v-if="value?.length || (mode == 'files' && files?.length)">
    <div class="linkfield__content">
      <div class="linkfield__name">{{ name }}</div>
      <div class="linkfield__value">
        <template v-if="mode == 'text'">{{ value }}</template>
        <template v-if="mode == 'files'">
          <File :actions="false" v-for="(f, i) in files" :key="f.name + i" :name="f.name" :size="filesizes[i]" :ext="fileexts[i]" />
        </template>
      </div>
    </div>
    <button class="linkfield__btn" @click="$store.commit('ad_storage/setStep', step)">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 12.125V18C19 19.1046 18.1046 20 17 20H7C5.89543 20 5 19.1046 5 18V8C5 6.89543 5.89543 6 7 6H13" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M17 6L11.5 11.5L11 14L13.5 13.5L19 8.00002M17 6L18 5.00001C18.5523 4.44772 19.4477 4.44772 20 5.00001V5.00001C20.5523 5.5523 20.5523 6.44773 20 7.00002L19 8.00002M17 6L19 8.00002" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>
</template>

<script>
import filesinfo from '@/mixins/filesinfo';
import File from './File.vue';

export default {
  mixins: [filesinfo],
  props: {
    step: { type: Number, required: true },
    name: { type: String, required: true },
    value: { required: true },
    mode: { type: String, default: "text" }
  },
  computed: {
    files() {
      if (this.mode != 'files') return []
      return this.value
    },
  },
  components: { File }
}
</script>

<style lang="sass" scoped>
.linkfield
  display: flex
  align-items: center
  padding: 19px 24px
  font-size: 16px
  line-height: 1.28
  color: colors.$gray5
  >*:not(:last-child)
    margin-right: 32px
  &__name, &__value
    flex-basis: 340px
    flex-grow: 1
    flex-shrink: 1
  &__btn
    align-self: flex-start
  &__value
    color: colors.$gray3
  &__content
    display: contents
  @include for-mob
    padding: 8px  
    margin: 24px 0
    &__content
      display: block
      flex-grow: 1
    &__name
      margin-bottom: 8px
</style>